<template lang="pug">
  lazy-component(@show="handler")  
    footer.footer
      .footer-intro
        a(id="instacart-footer-logo" href="https://www.instacart.com/")
          img.mx-auto(src="@/assets/images/powered-by-home.svg" alt="Instacart logo footer" width="320" height="68")
        p Beyond the Cart: A Year of Essential Stories
      .container-fluid.footer-body
        .row.footer_row
          .col-12.col-sm-4.col-md-4.footer_links
            .col-12.footer-cols
              .footer-cols__wrapper
                h3 
                  img(src="@/assets/images/carrot.svg", alt="Instacart deliveries" width="26" height="28")
                  | Get deliveries with Instacart
                ul.footer-list__icons
                  li
                    a(href="https://apps.apple.com/us/app/instacart/id545599256" target="_blank")
                      img(src="@/assets/images/ios.svg", alt="Instacart deliveries iOS App" width="16" height="18")
                      p iOS
                  li
                    a(href="https://play.google.com/store/apps/details?id=com.instacart.client" target="_blank")
                      img(src="@/assets/images/android.svg", alt="Instacart deliveries Android App" width="17" height="18")
                      p Android
          .col-12.col-sm-8.col-md-8
            .row
              .col-12.col-sm-12.col-md-3.footer-cols
                .footer-cols__wrapper
                  h3.footer-cols__button(@click="showAccordion($event)") Top departments
                  ul.footer-cols__list
                    li
                      a(href="https://www.instacart.com/store/categories/316-food/317-fresh-produce" target="_blank") Fresh Produce
                    li
                      a(href="https://www.instacart.com/store/categories/316-food/1326-dairy" target="_blank") Dairy Products
                    li
                      a(href="https://www.instacart.com/store/categories/316-food/1807-meat" target="_blank") Meat
                    li
                      a(href="https://www.instacart.com/store/categories/316-food/831-meat-alternatives" target="_blank") Meat Alternatives
                    li
                      a(href="https://www.instacart.com/store/categories/316-food/1974-seafood" target="_blank") Seafood
                    li
                      a(href="https://www.instacart.com/store/categories/316-food/844-pantry" target="_blank") Pantry Food
                    li
                      a(href="https://www.instacart.com/store/categories/316-food/1300-baked-goods" target="_blank") Baked Goods
                    li
                      a(href="https://www.instacart.com/categories" target="_blank") View all departments
                      
              .col-12.col-sm-12.col-md-3.footer-cols
                .footer-cols__wrapper
                  h3.footer-cols__button(@click="showAccordion($event)") More departments
                  ul.footer-cols__list
                    li
                      a(href="https://www.instacart.com/alcohol" target="_blank") Alcohol
                    li
                      a(href="https://www.instacart.com/store/categories/316-food/627-frozen-food" target="_blank") Frozen Food
                    li
                      a(href="https://www.instacart.com/store/categories/243-beverages" target="_blank") Beverages
                    li
                      a(href="https://www.instacart.com/shop/organic-food" target="_blank") Organic Grocery
                    li
                      a(href="https://www.instacart.com/store/categories/1361-household-essentials" target="_blank") Household Essentials
                    li
                      a(href="https://www.instacart.com/store/categories/1764-office-supplies" target="_blank") Office Supplies
                    li
                      a(href="https://www.instacart.com/store/categories/1484-beauty" target="_blank") Beauty Products

              .col-12.col-sm-12.col-md-3.footer-cols
                .footer-cols__wrapper
                  h3.footer-cols__button(@click="showAccordion($event)") Instacart programs
                  ul.footer-cols__list
                    li
                      a(href="https://www.instacart.com/gift-cards" target="_blank") Gift Cards
                    li
                      a(href="https://www.instacart.com/try-express" target="_blank") Instacart Express
                    li
                      a(href="https://ads.instacart.com?user_channel_2=&utm_campaign%5Butm_campaign%5D=instacart_advertising&utm_content=instacart_footer&utm_medium=landing_page&utm_source=instacart_internal&utm_term=visittoken-27a17f88-97de-4601-b203-2e9a2befc99d_visitortoken-f31d9d6b-cc06-4690-bef4-d5bf8c0fab05" target="_blank") Instacart Ads
                    li
                      a(href="https://aboutinstacart.com/partners" target="_blank") Partner Program
                    li
                      a(href="https://www.instacart.com/retailers" target="_blank") New retailers
                    li
                      a(href="https://www.instacart.com/walmart" target="_blank") Walmart
                    li
                      a(href="https://www.instacart.com/711" target="_blank") 7-Eleven
                    li
                      a(href="https://www.instacart.com/vitamin-shoppe" target="_blank") The Vitamin Shoppe
              .col-12.col-sm-12.col-md-3.footer-cols
                .footer-cols__wrapper
                  h3.footer-cols__button(@click="showAccordion($event)") Get to know us
                  ul.footer-cols__list
                    li
                      a(href="https://aboutinstacart.com" target="_blank") Contact
                    li
                      a(href="https://news.instacart.com" target="_blank") Press
                    li
                      a(href="https://www.instacart.com/help" target="_blank") Help
                    li
                      a(href="https://instacart.careers" target="_blank") Careers
                    li
                      a(href="https://www.instacart.com/privacy" target="_blank") Privacy
                    li
                      a(href="https://www.instacart.com/terms" target="_blank") Terms
                    li
                      a(href="https://www.instacart.com/grocery-delivery" target="_blank") Shop By Location
        .row.footer_row          
          .col-12.col-sm-4.col-md-4.footer_links
            .col-12.footer-cols
              .footer-cols__wrapper
                h3 
                  img(src="@/assets/images/shooper.svg", alt="Instacart shopper" width="23" height="26")
                  | Become a Shopper
                ul.footer-list__icons
                  li
                    a(href="https://apps.apple.com/us/app/instacart-shopper/id1454056744" target="_blank")
                      img(src="@/assets/images/ios.svg", alt="Instacart shopper iOS App" width="16" height="18")
                      p iOS
                  li
                    a(href="https://play.google.com/store/apps/details?id=com.instacart.shopper" target="_blank")
                      img(src="@/assets/images/android.svg", alt="Instacart shopper Android App" width="17" height="18")
                      p Android
                      
          .col-12.col-sm-8.col-md-8
            .row
              .col-12.col-sm-12.col-md-3.footer-cols
                .footer-cols__wrapper
                  h3.footer-cols__button(@click="showAccordion($event)") Make money with us
                  ul.footer-cols__list
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs" target="_blank") Shopper opportunities
                    li
                      a(href="https://shoppers.instacart.com/role/full-service" target="_blank") Become an Instacart Shopper
                    li
                      a(href="https://shoppers.instacart.com/role/in-store-shopper" target="_blank") In-Store Employee For Instacart
                    //li
                      a(href="https://instacartonboarding.zendesk.com/hc/en-us/articles/360027180271-Shopper-pay-and-earnings" target="_blank") Careers
                    li
                      a(href="https://instacartonboarding.zendesk.com/hc/en-us/articles/360027180271-Shopper-pay-and-earnings" target="_blank") Earnings
                      
              .col-12.col-sm-12.col-md-3.footer-cols
                .footer-cols__wrapper
                  h3.footer-cols__button(@click="showAccordion($event)") Top cities
                  ul.footer-cols__list
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-west-la" target="_blank") Los Angeles
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-lower-manhattan" target="_blank") New York City
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-chicago-il" target="_blank") Chicago
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-dc" target="_blank") Washington D.C.
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-san-francisco" target="_blank") San Francisco
                      
              .col-12.col-sm-12.col-md-3.footer-cols
                .footer-cols__wrapper
                  h3.footer-cols__button(@click="showAccordion($event)") More cities
                  ul.footer-cols__list
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-north-shore" target="_blank") North Shore
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-miami" target="_blank") Miami
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-las-vegas-nv" target="_blank") Las Vegas
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-atlanta" target="_blank") Atlanta
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs-in-dallas" target="_blank") Dallas
                    li
                      a(href="https://shoppers.instacart.com/instacart-jobs" target="_blank") View all Job Locations
                      
              .col-12.col-sm-12.col-md-3.footer-cols
                .footer-cols__wrapper
                  h3.footer-cols__button(@click="showAccordion($event)") Shopper help
                  ul.footer-cols__list
                    li
                      a(href="https://shoppers.instacart.com/help/help_center/login" target="_blank") Help
                    li
                      a(href="https://aboutinstacart.com/contact" target="_blank") Contact
                    li
                      a(href="https://covidresponse.instacart.com/shopper-resources" target="_blank") Safety
      .footer-legals
        hr
        .footer-legals__links
          .footer-legals__item Legal
          .footer-legals__item
            a(href="https://www.instacart.com/terms" target="_blank") Terms of Use
            a(href="https://www.instacart.com/privacy" target="_blank") Privacy Policy
          .footer-legals__item
            ul
              li
                a(id="footer-instagram-link" href="https://www.instagram.com/instacart/" target="_blank")
                  .svg
                    svg(viewBox="0 0 24 24")
                      path(d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z")
              li
                a(id="footer-twitter-link" href="https://twitter.com/instacart" target="_blank")
                  .svg
                    svg(viewBox="0 0 24 24")
                      path(d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z")
              li
                a(id="footer-facebook-link" href="https://www.facebook.com/Instacart" target="_blank")
                  .svg
                    svg(viewBox="0 0 155.139 155.139")
                      path(d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184 c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452 v20.341H37.29v27.585h23.814v70.761H89.584z")
              //li
                a(id="footer-pinterest-link" href="https://www.pinterest.com.mx/Instacart/_created/" target="_blank")
                  .svg
                    svg(viewBox="0 0 24 24")
                      path(d="m12.326 0c-6.579.001-10.076 4.216-10.076 8.812 0 2.131 1.191 4.79 3.098 5.633.544.245.472-.054.94-1.844.037-.149.018-.278-.102-.417-2.726-3.153-.532-9.635 5.751-9.635 9.093 0 7.394 12.582 1.582 12.582-1.498 0-2.614-1.176-2.261-2.631.428-1.733 1.266-3.596 1.266-4.845 0-3.148-4.69-2.681-4.69 1.49 0 1.289.456 2.159.456 2.159s-1.509 6.096-1.789 7.235c-.474 1.928.064 5.049.111 5.318.029.148.195.195.288.073.149-.195 1.973-2.797 2.484-4.678.186-.685.949-3.465.949-3.465.503.908 1.953 1.668 3.498 1.668 4.596 0 7.918-4.04 7.918-9.053-.016-4.806-4.129-8.402-9.423-8.402z")
        p.footer-disclaimer Apple and the Apple logo are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc. Android, Google Play and the Google Play logo are trademarks of Google LLC.
                
</template>
<script>
  
export default {
  data: function () {
      return {

      }
  },
  mounted: function () {

  },
  methods: {
    showAccordion(event){
      event.target.classList.toggle('open');
    },
    handler (component) {
        console.log('this component is showing', component)
      }
  }
}
</script>
<style lang="scss">
  .footer{
    background: $soft_brown;
    padding: 1rem;
    position: relative;
    overflow: hidden;
    @include respond-to('mobile'){
      padding: 2rem 2rem;
    }
    @include respond-to('small'){
      padding: 3rem 2rem;
    }
    &::before{
      content: "";
      position: absolute;
      top: -40%;
      width: 200%;
      left: -50%;
      height: 130%;
      border-radius: 50%;
      background-color: #FFFFFF;
      @include respond-to('small'){    
        width: 130%;
        left: -15%;
      }
    }
    &_row{
      padding: 1rem;
      border-bottom: none;
      @media screen and (min-width: 769px){
        border-bottom: 1px solid #C4C4C4;
      }
      &:nth-child(2){
        border-bottom: none;
      }
      .col-sm-4, .col-sm-8{
        @media screen and (max-width: 768px){
          flex: 0 0 100%;
          max-width: 100%;
        }
      }
      .footer_links{
        @media screen and (max-width: 768px){
          .footer-cols{
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
      &-intro{
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        flex-flow: column;
        z-index: 2;
        overflow: hidden;
        border-bottom: 1px solid #C4C4C4;
        img{
          width: 260px;
          height: auto;
          display: block;
          @include respond-to('mobile'){
            width: 320px;
          }
        }
        p{
          font-size: 0.8rem;
          margin: 1rem;
          position: relative;
          background: $white;
          display: table;
          @include respond-to('mobile'){
            font-size: 1rem;
          }
        }
    }
    &-body{
        margin: 1rem 0;
        position: relative;
        z-index: 2;
      @include respond-to('mobile'){
        margin: 2rem 0;
      }
    }
    &-cols{
        padding-top: 1rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #E8E9EB;
        padding-left: 0;
        padding-right: 0;
        &.col-md-3{
          @media screen and (max-width: 1023px){
            flex: 0 0 100%;
            max-width: 100%;
          }
        }
        @include respond-to('small'){
          padding-top: 0;
          padding-bottom: 0;
          border-bottom: none;
        }
      &__wrapper{
        h3{
          font-size: 1rem;
          font-weight: 900;
          color: #424242;
          text-align: center;
          margin-bottom: 1rem;
          position: relative;
          @include respond-to('small'){
            text-align: left;
          }
          &.footer-cols__button{
            border-bottom: none;
            padding: 0;
            margin: 0;
          
            cursor: pointer;
            &:last-child(){
              border-bottom: none;
            }
            &.open{
              &::after{
                transform: rotate(180deg);
              }
              ~ .footer-cols__list{
                display: block;
              }
            }
            &::after{
              content: '';
              background-image: url('~@/assets/images/icon-arrow-down.svg');
              position: relative;
              width: 15px;
              height: 11px;
              float: right;
              pointer-events: none;
              @media screen and (min-width: 1023px){
                display: none;
                border-bottom: none;
              }
            }
            @media screen and (min-width: 768px){
              border-bottom: 1px solid #E8E9EB;
              padding: 0 0 1rem 0;
              margin: 1rem 0;
            }
            @media screen and (min-width: 1023px){
              border-bottom: none;
              padding: 0;
              margin: 0;
              cursor: inherit;
            }
          }    
          img{
            margin-right: 0.25rem;
          }
        }
        .footer-cols__list{
          list-style-type: none;
          padding: 0;
          @media screen and (max-width: 1023px){
            display: none;
          }
          li{
            margin: 0.75rem 0;
            a{
              color: $gray;
              font-weight: normal;
              &:hover{
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
    &-list{
      &__icons{
        list-style-type: none;
        display: flex;
        justify-content: center;
        padding: 0;
        @include respond-to('small'){
          padding: 0 0 0 1rem;
          justify-content: flex-start;

        }
        li{
          margin: 0 1rem;
          a{
            display: flex;
            align-items: center;
            justify-content: center;
            p{
              margin: 0 0 0 0.5rem;
              color: $gray;
            }
          }
        }
      }
    }
    &-legals{
      position: relative;
      z-index: 2;
      padding: 0 15px;
      @include respond-to('small'){
        padding: 0;
      }
      hr{
        border-top: 1px solid #C4C4C4;
        display: none;
        @include respond-to('small'){
          display: block;
        }
      }
      &__links{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        color: #46484C;
        margin: 0 0.5rem 0 0;
        font-weight: 900;
        font-size: 1rem;
        @include respond-to('small'){
          
        }
        a{
          color: #46484C;
          margin: 0 0.75rem 0 0;
          font-weight: 900;
          font-size: 1rem;
          @include respond-to('small'){
            margin: 0 0.5rem 0 0;
          }
        }
      }
      &__item{
        width: 100%;
        margin: 0.75rem 0;
        &:first-child(){
          padding: 1rem;
        }
        @include respond-to('small'){
          width: auto;
          margin: 0;
        }
        > a{
          @include transition(all 0.5s ease 0s);
          &:hover{
            color: $orange;
          }
        }
        ul{
          list-style-type: none;
          margin: 0;
          padding: 0;
          display: flex;
          li{
            margin: 0;
            a{ 
              display: block;
              .svg{
                background: #46484C;
                border-radius: 50%;
                width: 30px;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 auto;
                @include transition(all 0.5s ease 0s);
                &:hover{
                  background: $white;
                  svg{
                    fill: $gray;
                  }
                }
                svg{
                  width: 15px;
                  height: 15px;
                  fill: $white;
                  @include transition(all 0.5s ease 0s);
                }
              }
              
            }
          }
        }
      }
    }
    &-disclaimer{
      color: $gray;
      font-size: 0.75rem;
      text-align: left;
      margin-top: 1rem;
      @include respond-to('small'){
        margin-top: 3rem;
        font-size: 0.875rem;
      }
    }
  }
</style>
